import React from "react";
import { Card, Col, Divider, Radio, Row, Spin, Typography } from "antd";
import TrabalheConoscoService from "./../../services/TrabalheConoscoService";
import NotificationUtil from "../../utils/NotificationUtil";
import ModalUltil from "./../../utils/ModalUtil";
import CommonUtil from "./../../utils/CommonUtil";
import IResponse from "../../contract/IResponse";
import UmkVagasList from "../../components/trabalhe-conosco/UmkVagasList";
import UmkCurriculoLogin from "./../../components/trabalhe-conosco/UmkCurriculoLogin";

const { Title, Paragraph, Text, Link } = Typography;

class TrabalheConoscoPage extends React.Component<any, any> {
	state = {
		loading: false,
		vagas: [],
	};

	private Common: CommonUtil;
	private NotificationService: NotificationUtil;
	private ModalUltil: ModalUltil;
	private TrabalheConoscoService: TrabalheConoscoService;

	constructor(props: any) {
		super(props);

		this.Common = new CommonUtil();
		this.TrabalheConoscoService = new TrabalheConoscoService();
		this.NotificationService = new NotificationUtil();
		this.ModalUltil = new ModalUltil(props);

		this.getVagas = this.getVagas.bind(this);
	}

	componentDidMount() {
		document.title = "Unimake Software - Trabalhe Conosco";
		this.getVagas();
	}

	async getVagas() {
		try {
			this.setState({ loading: true });

			let result = await this.TrabalheConoscoService.GetVagas();

			this.setState({ loading: false });

			let response: IResponse = result.data;

			if (response.success) {
				this.setState({
					vagas: response.data,
				});
			} else {
				this.ModalUltil.Exception(response.message);
			}
		} catch (error) {
			this.setState({ loading: false });
			this.ModalUltil.Exception(error);
		}
	}

	render() {
		return (
			<div>
				<section className="unimake-container">
					<Row justify="space-between">
						<Col sm={11} md={11} xs={24}>
							<Spin tip="Aguarde..." spinning={this.state.loading}>
								<UmkVagasList Vagas={this.state.vagas} />
							</Spin>
						</Col>
						<Col sm={11} md={11} xs={24}>
							<Title level={2}>Login</Title>
							<Title level={5}>Cadastre seu currículo ou atualize seus dados</Title>
							<Divider />
							<UmkCurriculoLogin />
						</Col>
					</Row>
				</section>
			</div>
		);
	}
}
export default TrabalheConoscoPage;
